export type AppLanguage = 'cn' | 'en';

export function normalizeAppLanguage(language?: string | null): AppLanguage | undefined {
  if (!language) return undefined;
  const normalized = language.toLowerCase().replace('_', '-');
  if (normalized === 'cn' || normalized.startsWith('zh-') || normalized === 'zh') return 'cn';
  if (normalized === 'en' || normalized.startsWith('en-')) return 'en';
  return undefined;
}

export function resolveAppLanguage(
  storedLanguage?: string | null,
  browserLanguages: readonly string[] = [],
): AppLanguage {
  const stored = normalizeAppLanguage(storedLanguage);
  if (stored) return stored;

  return normalizeAppLanguage(browserLanguages[0]) ?? 'en';
}
